import { defineStore } from "pinia";
import { useWebproductStore } from "@/stores/modules/webproduct";

export const useCheckedPageOptionsStore = defineStore("checkedpageoptions", {
  state: () => ({
    checkedData: {}
  }),

  getters: {
    getIsSummaryPageOptionActive(state) {
      const webproductStore = useWebproductStore();
      return webproductStore.getConfig.selected_page_option_summary
        ? parseInt(webproductStore.getConfig.selected_page_option_summary)
        : 0;
    },
    getIsCheckedPageOptionActive(state) {
      const webproductStore = useWebproductStore();
      return webproductStore.getConfig.checked_page_option
        ? parseInt(webproductStore.getConfig.checked_page_option)
        : 0;
    },
    getIsShowCheckedPageOptionFlag(state) {
      return false;
    },
    getChecked(state) {
      return function (po_index) {
        const webproductStore = useWebproductStore();
        return state.checkedData[webproductStore.getActiveProductPartCode][
          po_index
        ].checked;
      };
    },
    getCheckedInPP(state) {
      return function (payload) {
        for (
          var counter = 0;
          counter < Object.keys(state.checkedData[payload.pp]).length;
          counter++
        ) {
          if (state.checkedData[payload.pp][counter].code == payload.po_name) {
            return state.checkedData[payload.pp][counter].checked;
          }
        }

        return true;
      };
    },
    getCheckedIsNext(state) {
      return function (po_index) {
        const webproductStore = useWebproductStore();
        if (po_index == 0) {
          return true;
        }
        for (var i = 0; i < po_index; i++) {
          if (
            !state.checkedData[webproductStore.getActiveProductPartCode][i]
              .checked
          ) {
            return false;
          }
        }
        return true;
      };
    },
    getIndexProdPartItems(state) {
      return function (pp) {
        var previous = 0;
        for (var i = 0; i < Object.keys(state.checkedData).length; i++) {
          var ppKey = Object.keys(state.checkedData)[i];
          if (ppKey == pp) {
            return previous;
          }
          previous += Object.keys(state.checkedData[ppKey]).length;
        }

        return 0;
      };
    },
    getPPCanBeSelected(state) {
      return function (pp) {
        for (var i = 0; i < Object.keys(state.checkedData).length; i++) {
          var ppKey = Object.keys(state.checkedData)[i];
          if (ppKey == pp) {
            return true;
          }
          for (var j in state.checkedData[ppKey]) {
            if (!state.checkedData[ppKey][j].checked) {
              return false;
            }
          }
        }

        return false;
      };
    }
  },

  actions: {
    setCheckedPOData(payload) {
      if (
        !this.getIsCheckedPageOptionActive &&
        !this.getIsSummaryPageOptionActive
      ) {
        return;
      }
      var data = {};
      for (const objIdx in payload) {
        const obj = payload[objIdx];
        var allPageOptions = obj.page_options;
        var options = Object.keys(allPageOptions)
          .filter(item => {
            return allPageOptions[item].hidden == 0;
          })
          .reduce((obj, key, index) => {
            obj[index] = { checked: false, code: key };
            return obj;
          }, {});

        data[obj.code] = options;
      }
      this.checkedData = data;
    },
    setCheckedPOItem(payload) {
      if (
        !this.getIsCheckedPageOptionActive &&
        !this.getIsSummaryPageOptionActive
      ) {
        return;
      }
      var data = {
        ...this.checkedData
      };
      data[payload.pp][payload.po_index].checked = true;
      for (
        var i = payload.po_index + 1;
        i < Object.keys(data[payload.pp]).length;
        i++
      ) {
        data[payload.pp][i].checked = false;
      }

      var setNotChecked = false;
      for (var i = 0; i < Object.keys(this.checkedData).length; i++) {
        var ppKey = Object.keys(this.checkedData)[i];
        if (ppKey == payload.pp) {
          setNotChecked = true;
          continue;
        }
        if (!setNotChecked) {
          continue;
        }
        for (var j in this.checkedData[ppKey]) {
          this.checkedData[ppKey][j].checked = false;
        }
      }

      this.checkedData = data;
    }
  }
});
